import { GET_AFFAIRCATEGORIES, OPEN_AFFAIR,CLOSE_AFFAIR, GET_AFFAIRSTATUS, GET_AFFAIRAUTOMATED, GET_AUTOCOMPLETEAFFAIR } from '../actions/types'

export default function personsReducer(state = {}, action) {
  switch (action.type) {
    case GET_AFFAIRCATEGORIES:
      return {...state, affaircategories: action.affaircategories}
    case GET_AFFAIRSTATUS:
      return {...state, affairstatus: action.affairstatus}
    case GET_AFFAIRAUTOMATED:
      return {...state, affairautomated: action.affairautomated}
    case OPEN_AFFAIR:
      return {...state, thisaffair: action.affair, editedaffair: action.affair}
    case CLOSE_AFFAIR:
      delete state.thisaffair
      return {...state}
    case GET_AUTOCOMPLETEAFFAIR:
      return {...state, autocomplete: action.payload}

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/tb_reducer.js